// extracted by mini-css-extract-plugin
export default {"container":"Chat_container__PLEd4","refresh":"Chat_refresh__BpHlh","list":"Chat_list__bvia7"};